import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { Creators as DialogCreators } from "modules/dialog/model"
import DashboardSearch from "../components/search"
import { IDashboardContext } from "../context/types"
import { SelectedInstrument } from "helpers/types/instruments/selected"
import type { InstrumentSelectionData } from "../analytics"

// [TODO] Move outside of dashboard once link to dashboard context has been severed
/**
 * Returns pre-configured callback to open the Unified Search
 * @param context [TODO] Removes relation to dashboard context, plug into new Instrument Context when ready
 * @param setInstrument callback to set instrument
 * @param searchType "benchmark" or "base" are supported for now. Enlarge type as this makes it out of the dashboard.
 * @param selectedInstrument used to load experiments if available
 * @param disableModelSelector disable model selection inside search
 * @param includeBenchmarks include benchmarks in available instruments
 * @param onInstrumentSelection callback for tracking instrument selection events
 */
export default function useOpenUnifiedSearch(
  context: IDashboardContext,
  setInstrument: (instrument: SelectedInstrument | null) => void,
  searchType: string,
  selectedInstrument: SelectedInstrument | null = null,
  disableModelSelector = false,
  includeBenchmarks = false,
  onInstrumentSelection?: (data: InstrumentSelectionData) => void,
) {
  const dispatch = useDispatch()

  return useCallback(() => {
    dispatch(DialogCreators.open({
      content: <DashboardSearch
        // `close` is provided by dialog component
        close={undefined as never}
        context={context}
        searchType={searchType}
        setInstrument={setInstrument}
        selectedInstrument={selectedInstrument}
        disableModelSelector={disableModelSelector}
        includeBenchmarks={includeBenchmarks}
        onInstrumentSelection={onInstrumentSelection}
      />,
    }))
  }, [dispatch, context, searchType, setInstrument, selectedInstrument, disableModelSelector, includeBenchmarks, onInstrumentSelection])
}
